// src/axiosConfig.js
import axios from "axios";


// ✅ Monorepo no Railway: front e back no mesmo host
// Em dev, você pode setar REACT_APP_API_URL=http://localhost:3001
const BASE_URL = process.env.REACT_APP_API_URL || "";

// ✅ Instância de Axios com suporte a credenciais (cookies, CORS)
const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  withCredentials: false, // JWT vai no Authorization header
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  transitional: {
    clarifyTimeoutError: true
  }
});

// 🔐 Interceptor de requisição para incluir token JWT
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("⚠️ Token não encontrado no localStorage.");
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// 🛡️ Interceptor de resposta com tratamento de erros
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error(`❌ [${error.response.status}]`, error.response.data?.error || error.message);

      if (error.response.status === 401) {
    const pathname = window.location.pathname;
    const requestUrl = error.config?.url || "";

    const estaNaTelaLogin =
        pathname === "/login";

    const erroVeioDoLogin =
      requestUrl.includes("/login");

    if (estaNaTelaLogin || erroVeioDoLogin) {
      return Promise.reject(error);
    }

    const estaNoFluxoEvento = pathname.startsWith("/eventos/");


    if (estaNoFluxoEvento) {
      console.warn("⚠️ Ignorando 401 no fluxo de evento para evitar logout.");
      return Promise.reject(error);
    }

    // ⚠️ Redirecionar normalmente no restante do sistema
    localStorage.removeItem("usuario");
    localStorage.removeItem("token");

    window.location.replace("/login?motivo=expirado");
  }

      
    } else {
      console.error("🚫 Erro de rede:", error.message);
    }

    return Promise.reject(error);
  }
);

export default instance;
export { BASE_URL };
